import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const client = axios.create({ baseURL: API });

client.interceptors.request.use((config) => {
  const token = sessionStorage.getItem("salnes_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

// If the server rejects the JWT (expired or invalid) redirect to /login so
// the user sees a clear "session expired" state instead of an empty UI.
client.interceptors.response.use(
  (r) => r,
  (err) => {
    const status = err?.response?.status;
    const url = err?.config?.url || "";
    if (status === 401 || status === 403) {
      // Public endpoints (starting with /public) never require auth; ignore.
      const isPublic = url.includes("/public/") || url.includes("/auth/");
      const path = typeof window !== "undefined" ? window.location.pathname : "";
      const alreadyOnLogin = path.startsWith("/login");
      if (!isPublic && !alreadyOnLogin && typeof window !== "undefined") {
        try {
          sessionStorage.removeItem("salnes_token");
          // Set a persistent flag so the /login banner appears even when
          // React's <ProtectedRoute> outraces our hard redirect.
          sessionStorage.setItem("salnes_session_expired", "1");
        } catch {
          /* ignore */
        }
        // Notify AuthContext synchronously so any cached `user` is cleared
        // before <Navigate> guards evaluate.
        try {
          window.dispatchEvent(new Event("salnes:session-expired"));
        } catch {
          /* ignore */
        }
        // Small delay so the current render cycle can propagate a toast.
        setTimeout(() => {
          window.location.href = "/login?expired=1";
        }, 100);
      }
    }
    return Promise.reject(err);
  }
);

export default client;

export const fetcher = (url) => client.get(url).then((r) => r.data);
